var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('polygon',{staticStyle:{"fill":"currentColor"},attrs:{"points":"12 1.164 10.836 0 6 4.836 1.164 0 0 1.164 4.836 6 0 10.836 1.164 12 6 7.164 10.836 12 12 10.836 7.164 6 12 1.164"}})}
var staticRenderFns = []

export { render, staticRenderFns }